import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
});

// Inventory screens often remain open while another tab or admin makes edits.
// Give the Redis-backed aggregate and cheap list queries a throttled focus
// refresh, while expensive project/detail queries stay on the global no-focus
// default and continue to refresh explicitly after local mutations.
for (const queryKey of [
  ['admin-inventory-projects'],
  ['admin-inventory-projects-light'],
  ['admin', 'payments', 'all'],
  ['admin', 'issuances-list'],
  ['admin', 'retirements-list'],
  ['inventory-project-payments'],
  ['inventory-project-issuances'],
  ['inventory-project-retirements'],
]) {
  queryClient.setQueryDefaults(queryKey, {
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });
}

const DASHBOARD_QUERY_KEYS = [
  'offset_orders',
  'tree_orders',
  'project_donations',
  'impactCalendar',
  'footprints',
  'footprintRanking',
  'notifications',
  'climate_action_stats',
  'user_climate_actions',
];

export function invalidateDashboardQueries() {
  for (const key of DASHBOARD_QUERY_KEYS) {
    queryClient.invalidateQueries({ queryKey: [key] });
  }
}
